export const ENV = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  TEST: 'test'
}

export const HTTP_STATUS_CODE = {
  OK: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403, // session expire
};

export const HIDDEN_FORM_TYPE_CODES = ["LEAVE"];

export const HIDDEN_REPORT_CODES = ["LeaveByMajor"];
